module.exports = __webpack_public_path__ + "static/img/24.eff6d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/24.png
// module id = QkIh
// module chunks = 1